import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  alpha,
} from "@mui/material";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import RocketLaunchRoundedIcon from "@mui/icons-material/RocketLaunchRounded";
import MDButton from "components/MDButton";

/*
  InsufficientCreditsModal
  ──────────────────────────────────────────────────────────────
  Mirrors the mobile `promptInsufficientCredits` Alert with the
  same wording. The "Subscribe" CTA is a no-op stub on web for
  now — the web dashboard doesn't host the in-app-purchase flow,
  so we link to the marketing site / Stripe portal here. If a
  paid-tier upsell ever lands on web, just swap the onSubscribe
  handler at the call site.
*/

export default function InsufficientCreditsModal({
  open,
  onClose,
  required,
  remaining,
  onSubscribe,
}) {
  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ pb: 0.5 }}>
        <Stack direction="row" alignItems="center" spacing={1.2}>
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={(theme) => ({
              width: 36,
              height: 36,
              borderRadius: 2,
              backgroundColor: alpha(theme.palette.warning.main, 0.14),
              color: theme.palette.warning.dark,
            })}
          >
            <BoltRoundedIcon />
          </Stack>
          <Typography variant="h6" fontWeight={700}>
            Not enough AI credits
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          This action costs{" "}
          <Typography component="span" variant="body2" fontWeight={700}>
            {required ?? "—"}
          </Typography>{" "}
          credit{required === 1 ? "" : "s"} but you only have{" "}
          <Typography component="span" variant="body2" fontWeight={700}>
            {remaining ?? 0}
          </Typography>{" "}
          remaining. Upgrade to keep generating quizzes, flashcards and chats with Microlab Copilot.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <MDButton variant="text" color="dark" onClick={onClose}>
          Cancel
        </MDButton>
        <MDButton
          variant="gradient"
          color="info"
          startIcon={<RocketLaunchRoundedIcon />}
          onClick={() => {
            if (typeof onSubscribe === "function") {
              onSubscribe();
            } else {
              // Fallback — open marketing pricing page in a new tab.
              window.open("https://microlab.help/#pricing", "_blank", "noopener");
            }
            if (typeof onClose === "function") onClose();
          }}
        >
          Upgrade
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
